import { render, staticRenderFns } from "./CaseDetail.vue?vue&type=template&id=3dbb38a8"
import script from "./CaseDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseDetail.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports